import React, { useCallback, useState } from 'react';
import "./style/inviteUserForm.css";
import MainService from "../services/main-service";

const InviteUserForm = (props) => {
  const { email, owner } = props;
  const [btnClicked, setBtnClicked] = useState(false);

  const resendInvitationEmail = useCallback(async () => {
    setBtnClicked(true);
    const request = { email, owner }
    const response = await MainService.inviteUser(request);
    if (response.status === 200) {
      const btn = document.getElementById('resend');
      if (btn) {
        btn.value = 'Sent';
        await new Promise(r => setTimeout(r, 5000));
        setBtnClicked(false);
        btn.value = 'Resend';
      }
    } else {
      // Todo: error message
      setBtnClicked(false);
    }
  }, []);

  return (
    <>
      <div className="email-verification">
        <div className="title">Email verification</div>
        <div className="invite-user-container">
          <div className="image-container">
            <img src="/fynd_app_banner.png" alt="visenzeImage" style={{ width: '443px', height: '425px' }} />
          </div>
          <div className="form-container">
            <div className="form">
              <img src="/visenze_logo.png" alt="visenzeLogo" style={{ width: '80px', height: '16px' }} />
              <div className="email-title">Check your email, activate your ViSenze account</div>
              <div className="explanation">
                We’ve sent invitation link to below email address.<br />
                Activate your account within Discovery Suite.
              </div>
              <div className="email-container">
                Email
                <input
                  className="email"
                  value={email}
                  disabled={true}
                />
              </div>
              <div className="resend-container">
                Didn’t receive an email?
                <input
                  id="resend"
                  type="submit"
                  className="resend-btn"
                  value="Resend"
                  onClick={resendInvitationEmail}
                  disabled={btnClicked}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}

export default InviteUserForm;